export default __webpack_public_path__ + "static/media/3stepweightloss@3x.8201c25a.jpg";